import React from 'react';
import { Section } from './ui/Section';
import { useLanguage } from '../context/LanguageContext';
export function SystemBreakdown() {
  const {
    t
  } = useLanguage();
  return <Section data-id="element-151">
      <div className="text-center mb-20" data-id="element-152">
        <h2 className="font-serif text-4xl md:text-6xl mb-6 text-white" data-id="element-153">
          {t.systemBreakdown.headline.line1} <br data-id="element-154" />
          <span className="text-luxury-gold italic" data-id="element-155">
            {t.systemBreakdown.headline.span}
          </span>
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-156">
        {t.systemBreakdown.pillars.map((pillar, i) => <div key={i} className="group p-10 border border-white/10 hover:border-luxury-gold/50 transition-all duration-500 bg-luxury-charcoal/20" data-id="element-157">
            <span className="block text-6xl font-serif text-luxury-gold/20 mb-6 group-hover:text-luxury-gold/40 transition-colors" data-id="element-158">
              0{i + 1}
            </span>
            <h3 className="font-serif text-2xl mb-4 text-white" data-id="element-159">
              {pillar.title}
            </h3>
            <p className="text-luxury-gray font-light leading-relaxed" data-id="element-160">
              {pillar.desc}
            </p>
          </div>)}
      </div>
    </Section>;
}